import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Bestaetigt from './components/Bestaetigt';
import Login from './components/Login';
import NotFound from './components/NotFound';
import Notdienst from './components/Notdienst';
import Provision from './components/Provision';
import ProvisionSmall from './components/ProvisionSmall';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import $ from 'jquery';
import Popper from 'popper.js';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import * as serviceWorker from './serviceWorker';

serviceWorker.register();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <Routes>
          <Route path="/" element={ <NotFound/> }/>
          <Route path="/organizer" element={<App />} />
          <Route path="/organizer/bestaetigt/:id" element={<Bestaetigt />} />
          <Route path="/organizer/notdienst/:id" element={<Notdienst />} />
          <Route path="/organizer/login" element={<Login />} />
          <Route path="/organizer/provision" element={<Provision />} />
          <Route path="/organizer/provisionsmall" element={<ProvisionSmall />} />
          <Route path="/*" element={ <NotFound/> }/>
      </Routes>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
